import React, { createContext, useState, useContext } from 'react';

interface Permissions {
    can_read_projects: boolean;
    can_edit_projects: boolean;
    can_read_products: boolean;
    can_edit_products: boolean;
}

interface PermissionsContextType {
    permissions: Permissions | null;
    setPermissions: React.Dispatch<React.SetStateAction<Permissions | null>>;
}

const PermissionsContext = createContext<PermissionsContextType | null>(null);

export const usePermissions = () => {
    const context = useContext(PermissionsContext);
    if (!context) {
        throw new Error('usePermissions must be used within a PermissionsProvider');
    }
    return context;
};

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [permissions, setPermissions] = useState<Permissions | null>(null);

    return (
        <PermissionsContext.Provider value={{ permissions, setPermissions }}>
            {children}
        </PermissionsContext.Provider>
    );
};
